import { render, staticRenderFns } from "./ppc.vue?vue&type=template&id=3b58d278"
import script from "./ppc.vue?vue&type=script&lang=js"
export * from "./ppc.vue?vue&type=script&lang=js"
import style0 from "./ppc.vue?vue&type=style&index=0&id=3b58d278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports